import { useAppContext } from '../useAppContext';

const useCurrentEmail = () => {
  const [{ user }] = useAppContext();
  const email = user && user.attributes && user.attributes.email;
  return [{ data: email, loading: !email }];
};

export default useCurrentEmail;
